export const LocalKeys = {
  AUTH_TOKEN: 'auth',
  REFRESH_TOKEN: 'refresh.token',
  AUTH_TOKEN_EXPIRY: 'auth.token_expiry',
  SELECTED_WORKSPACE: 'selected_workspace',
}

export const setLocalKey = (key: string, value: string) => {
  localStorage.setItem(key, value)
}

export const getLocalKey = (key: string) => {
  return localStorage.getItem(key)
}
